import React, { useState } from 'react';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { convertDateFromServer } from 'app/shared/util/date-utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, useParams } from 'react-router-dom';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import { WrittenStatementViewModel } from 'app/edozvola/cases/case-technical-inspection/model/case-technical-inspection.model';
import { deleteWrittenStatementQuery, fetchWrittenStatementsTableQuery } from 'app/edozvola/cases/case-technical-inspection/service/case-technical-inspection.queries';
import { getWrittenStatementFile } from './service/case-technical-inspection.service';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { TABLE_QUERY_KEYS } from 'app/config/constants';
import { getInvalidRowsForTable } from 'app/shared/util/validation-errors.util';
import { getCaseContext } from 'app/shared/util/context-util';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';
import error = toast.error;
import { openFileInNewWindow } from 'app/shared/util/navigation-util';

const WrittenStatementTable = ({ setWrittenStatement, setReadOnly }) => {
  const { id } = useParams<{ id: string }>();
  const { sidebarItemPair } = getCaseContext();

  const invalidRowIds = getInvalidRowsForTable(TABLE_QUERY_KEYS.WRITTEN_STATEMENTS_TABLE);

  const [idWrittenStatementToDelete, setIdWrittenStatementToDelete] = useState();
  const [deleteModalShown, setDeleteModalShown] = useState(false);

  const { mutate: deleteWrittenStatement, isPending: deletingWrittenStatement } = deleteWrittenStatementQuery();

  const openWrittenStatementForm = (idWrittenStatement: number, readOnly: boolean) => {
    setWrittenStatement(idWrittenStatement);
    setReadOnly(readOnly);
  };

  const openDeleteDialog = idToDelete => {
    setIdWrittenStatementToDelete(idToDelete);
    setDeleteModalShown(true);
  };

  const removeWrittenStatement = () => {
    setDeleteModalShown(false);
    deleteWrittenStatement(idWrittenStatementToDelete);
  };

  const downloadFile = (idwritenStatement: number, fileName: string) => {
    getWrittenStatementFile(idwritenStatement)
      .then(data => {
        if (data) {
          openFileInNewWindow(data.url)
        }
      })
      .catch(err => showToast(error, 'Dogodila se greška prilikom preuzimanja dokumenta.'));
  };

  const renderTableRow = (value: WrittenStatementViewModel, reportIndex: number, totalItems: number) => {
    return (
      <tr key={reportIndex} className={invalidRowIds.includes(value.idWrittenStatement) ? 'invalid-table-row' : ''}>
        <td>
          <div className={'column-with-multiple-data'}>
            <span>{value.writtenStatementType}</span>
            <span>{value.workType}</span>
          </div>
        </td>
        <td>
          <span>{value.siteConstructor}</span>
        </td>
        <td>{value.buildingDiaryCode}</td>
        <td>
          <span>{value.mark}</span>
        </td>
        <td>
          <span>{convertDateFromServer(value.statementDate)}</span>
        </td>
        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canViewDocument && value.hasAttachment && (
              <TooltipWrapper message={'Pregledaj dokument'}>
                <FontAwesomeIcon
                  icon={'file'}
                  className={'icon-table'}
                  onClick={() => downloadFile(value.idWrittenStatement, value.writtenStatementType)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canView && (
              <TooltipWrapper message={'Pregledaj izjavu'}>
                <FontAwesomeIcon
                  icon={'eye'}
                  className={'icon-table'}
                  onClick={() => openWrittenStatementForm(value.idWrittenStatement, true)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canEdit && (
              <TooltipWrapper message={'Uredi'}>
                <FontAwesomeIcon
                  icon={'pen-to-square'}
                  className={'icon-table'}
                  onClick={() => openWrittenStatementForm(value.idWrittenStatement, false)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canDelete && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon icon={'trash-alt'} className={'icon-table'} onClick={() => openDeleteDialog(value.idWrittenStatement)} />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        initialPaginationColumn={'writtenStatementType'}
        renderTableRow={renderTableRow}
        fetchDataQuery={fetchWrittenStatementsTableQuery}
        fetchDataProps={id}
        noDataMessage={'Nema dodanih pisanih izjava.'}
      >
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Pisana izjava', 'Vrsta radova']} width={'280px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Izvođač radova']} width={'240px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Građevinski dnevnik']} width={'150px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Oznaka']} width={'100px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Datum izrade']} width={'80px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'100px'} />
      </ViewTable>

      <Modal scrollable isOpen={deleteModalShown} size={'lg'} toggle={() => setDeleteModalShown(false)} centered>
        <ModalHeader>
          <span>Brisanje izjave</span>
        </ModalHeader>
        <ModalBody>
          <div>Jeste li sigurni da želite obrisati podatke?</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label="Odustani" outline onClick={() => setDeleteModalShown(false)} color={'secondary'} />
          <Button size={'lg'} label="Obriši" onClick={removeWrittenStatement} color={'danger'} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default WrittenStatementTable;
